import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { TokenReaderService } from '@/app/services/security/token-reader.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent {
  title = 'CombustiblesFrontV2';
  protected authService = inject(AuthService);
  private tokenReader = inject(TokenReaderService);

  protected usuario = this.tokenReader.usuario;
}
